import Vue from 'vue'

const debug = false

export default ({ account, ui }) => {
  return new Vue({
    data () {
      return {
        event: null
      }
    },
    methods: {
      flushEvents() {
        if(this.event !== null) {
          this._event(this.event)
          this.event = null
        }
      },
      _event(path) {
        if (window.clicky) {
          if(account.isImpersonated) {
            if(debug) console.log('[CLICKY] Ignore impersonation event ' + path)
          } else {
            if(debug) console.log('[CLICKY] Sending event ' + path)
            window.clicky.log(path)
          }
        } else {
          if(debug) console.log('[CLICKY] Saving event ' + path)
          this.event = path
        }
      },
      logBrowse(path) {
        this._event(path)
      },
      logOpenDialog(dialog) {
        this._event('/dialog/' + dialog)
      }
    },
    created () {
      // Prepare global variable if not present on window
      if (!('clicky_custom' in window)) {
        window.clicky_custom = {}
        window.clicky_custom.visitor_consent = 1
        window.clicky_custom.pageview_disable = 1
        window.clicky_custom.history_disable = 1
        window.clicky_custom.outbound_disable = 1
        window.clicky_custom.session = {
          username: null,
          email: null,
          appversion: ui.app.version,
        }
      }

      if (account.isVerified) {
        if(!account.isImpersonated) {
          window.clicky_custom.session.username = account.current.first_name + ' ' + account.current.last_name
          if (account.current.company) {
            window.clicky_custom.session.username += ' (' + account.current.company + ')'
          }
          window.clicky_custom.session.email = account.current.email
          if(debug) console.log('[CLICKY] Set user session ', window.clicky_custom.session)
        } else {
          if(debug) console.log('[CLICKY] Ignore impersonation user session')
        }
      } else {
        window.clicky_custom.session.username = null
        window.clicky_custom.session.email = null
        if(debug) console.log('[CLICKY] Set empty user session')
      }
    }
  })
}